import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String,
  };

  async share(event) {
    event.preventDefault();

    const shareData = {
      title: this.titleValue || document.title,
      text: this.textValue || "",
      url: this.urlValue || window.location.href,
    };

    // Try native share API first (works on mobile and some desktop browsers)
    if (navigator.share && this.canShare(shareData)) {
      try {
        await navigator.share(shareData);
        return;
      } catch (error) {
        // User cancelled or share failed, fall through to clipboard
        if (error.name === "AbortError") {
          return; // User cancelled, do nothing
        }
      }
    }

    // Fallback: copy to clipboard
    await this.copyToClipboard(shareData.url);
  }

  canShare(data) {
    try {
      return navigator.canShare && navigator.canShare(data);
    } catch {
      return false;
    }
  }

  async copyToClipboard(url) {
    try {
      await navigator.clipboard.writeText(url);
      this.showFeedback(true);
    } catch {
      // Fallback for older browsers
      this.fallbackCopyToClipboard(url);
    }
  }

  fallbackCopyToClipboard(url) {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand("copy");
      this.showFeedback(true);
    } catch {
      this.showFeedback(false);
    }

    document.body.removeChild(textArea);
  }

  showFeedback(success) {
    const originalContent = this.element.innerHTML;
    const feedbackText = success ? this.copiedText : this.errorText;

    this.element.innerHTML = `<span>${feedbackText}</span>`;
    this.element.classList.add("pointer-events-none");

    setTimeout(() => {
      this.element.innerHTML = originalContent;
      this.element.classList.remove("pointer-events-none");
    }, 2000);
  }

  get copiedText() {
    return this.element.dataset.shareCopiedText || "Link copied!";
  }

  get errorText() {
    return this.element.dataset.shareErrorText || "Failed to copy";
  }
}
